export var CryptoProtocolType;
(function (CryptoProtocolType) {
    CryptoProtocolType["ERC20"] = "erc20";
    CryptoProtocolType["TRC20"] = "trc20";
    CryptoProtocolType["TOPAY"] = "topay";
    CryptoProtocolType["EBPAY"] = "ebpay";
    CryptoProtocolType["CGPAY"] = "cgpay";
    CryptoProtocolType["CGPAY_USDT"] = "cgpay_usdt";
    CryptoProtocolType["KOIPAY"] = "koipay";
    CryptoProtocolType["GOUBAO"] = "goubao";
    CryptoProtocolType["PAY988"] = "pay988";
    CryptoProtocolType["PAY808"] = "pay808";
    CryptoProtocolType["KDPAY"] = "kdpay";
})(CryptoProtocolType || (CryptoProtocolType = {}));
//# sourceMappingURL=CryptoProtocolType.js.map